import cookieHandler from "AtomicUtils/cookieHandler"

export const gtmEventTypes = {
  CHECK_VIN: "FED-RECALLS-001",
  CLICK_CTA: "FED-RECALLS-002"
}

export const gtmEvents = {
  [gtmEventTypes.CHECK_VIN]: ({ result }) => ({
    type: gtmEventTypes.CHECK_VIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CHECK_VIN,
    pageCategory: "Recalls",
    pageAction: `Recalls - Enter VIN - Recall Status "${result.toUpperCase()}"`
  }),
  [gtmEventTypes.CLICK_CTA]: ({ ctaName, result }) => ({
    type: gtmEventTypes.CLICK_CTA,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: "Recalls",
    pageAction: `Recalls - Recall Status "${result}" - Clicked "${ctaName.toUpperCase()}"`
  })
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/recalls-block-duck.js